import apiService from '@/api/apiService';

export const login = async (email, password) => {
    const url = '/api/admin/login';
    const data = {
        email: email,
        password: password
    };

    return apiService.POST(url, data);
};
